<template>
  <div class="on-off-switch" :class="{ transitioning, disabled }">
    <label :for="idCalc">
      <input
        type="checkbox"
        :id="idCalc"
        @change="emitChange"
        :checked="value"
        :disabled="disabled"
      />
      <span class="slider">
        <span class="slide-toggle" />
      </span>
    </label>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { uniqueId } from "lodash-es";
import { useTheme } from "@/utils/index";

export default {
  name: "Toggle",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    id: Number,
    transitioning: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { theme } = useTheme();

    const colorChecked = computed(() => theme.value?.iconColors?.xi);
    const colorDisabled = computed(() => theme.value?.iconColors?.lambda);
    const colorUnchecked = computed(() => theme.value?.iconColors?.nu);
    const emitChange = (e) => {
      emit("input", e.target.checked);
      emit("change", e.target.checked);
    };
    const idCalc = computed(() => props.id || uniqueId("toggle-"));
    const switchColor = computed(() => theme.value?.iconColors?.eta);

    return {
      colorChecked,
      colorDisabled,
      colorUnchecked,
      emitChange,
      idCalc,
      switchColor,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.on-off-switch {
  &.disabled,
  &.transitioning {
    cursor: not-allowed;
    label {
      pointer-events: none;
      input,
      input:checked {
        + .slider {
          -webkit-transition: 1s;
          transition: 1s;
        }
      }
    }
  }
  &.disabled {
    opacity: 0.5;
  }

  &.transitioning {
    .slider {
      > .slide-toggle {
        &:after {
          border-style: solid;
          border-top-width: 2px;
          border-left-width: 2px;
          border-bottom-width: 1px;
          border-right-width: 2px;
          -webkit-animation: spinner 1s linear infinite;
          animation: spinner 1s linear infinite;

          @keyframes spinner {
            to {
              transform: rotate(360deg);
            }
          }
        }
      }
    }
  }

  label {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    margin: 5px 10px;
    vertical-align: bottom;

    input {
      display: none;
      &:checked {
        + .slider {
          > .slide-toggle {
            -webkit-transform: translateX(22px);
            -ms-transform: translateX(22px);
            transform: translateX(22px);
          }
        }
      }
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 93px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 40px;
      z-index: 5;
      > .slide-toggle {
        display: block;
        position: absolute;
        content: "";
        height: 24px;
        width: 24px;
        left: -3px;
        bottom: -2px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
        &:after {
          box-sizing: inherit;
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 100%;
          border-width: 0;
          border-style: solid;
        }
      }
    }
  }
}
</style>
